angular
    .module('WizApp')
    .component('registerForm', {
        bindings: {
            slug: '<?',
            type: '<?'
        },
        controller: [
            '$rootScope',
            '$scope',
            '$window',
            'AuthenticationService',
            'AnalyticsService',
            'WizAppAnalyticsService',
            'NoticeService',
            'ErrorFactory',
            'EVENT_NAMES',
            'CookiesConsentService',
            function ($rootScope, $scope, $window, AuthenticationService, AnalyticsService, WizAppAnalyticsService, NoticeService, ErrorFactory, EVENT_NAMES, CookiesConsentService) {
                const vm = this;

                vm.firstName = null;
                vm.lastName = null;
                vm.username = null;
                vm.password = null;

                vm.formLoading = false;
                vm.facebookLoading = false;
                vm.googleLoading = false;
                vm.facebookCookieActivator = false;
                vm.googleCookieActivator = false;
                vm.facebookActivated = false;
                vm.googleActivated = false;

                vm.invalidCredentials = false;
                vm.cguAccepted = false;

                vm.onSubmit = onSubmit;
                vm.isAnythingLoading = isAnythingLoading;
                vm.openCGU = openCGU;
                vm.handleCookieActivatorClick = handleCookieActivatorClick;

                vm.resetCredentialsValidity = () => { vm.invalidCredentials = false };

                $scope.$on(EVENT_NAMES.facebookConnect.start, () => {
                    vm.facebookLoading = true;
                });

                $scope.$on(EVENT_NAMES.facebookConnect.success, () => {
                    // TODO change this when used outside the job register
                    AnalyticsService
                        .send({ event: 'Register', category: 'Facebook', label: 'Register Job' })
                        .finally(function () {
                            $window.location.href = '/';
                        });
                });

                $scope.$on(EVENT_NAMES.facebookConnect.error, () => {
                    vm.facebookLoading = false;
                });


                $scope.$on(EVENT_NAMES.googleConnect.start, () => {
                    vm.googleLoading = true;
                });

                $scope.$on(EVENT_NAMES.googleConnect.success, () => {
                    // TODO change this when used outside the job register
                    AnalyticsService
                        .send({ event: 'Register', category: 'Google', label: 'Register Job' })
                        .finally(function () {
                            $window.location.href = '/';
                        });
                });

                $scope.$on(EVENT_NAMES.googleConnect.error, () => {
                    vm.googleLoading = false;
                });

                $scope.$on('$destroy', () => {
                    WizAppAnalyticsService.resetGaPage();
                });

                $scope.$on(EVENT_NAMES.facebookConnect.cookieActivator, () => {
                    vm.facebookCookieActivator = true;
                    vm.googleCookieActivator = false;
                });

                $scope.$on(EVENT_NAMES.googleConnect.cookieActivator, () => {
                    vm.googleCookieActivator = true;
                    vm.facebookCookieActivator = false;
                });

                function onSubmit() {
                    if (vm.isAnythingLoading()) {
                        return;
                    }

                    vm.formLoading = true;

                    const { firstName, lastName, username, password, slug, type } = vm;

                    AuthenticationService
                        .register({
                            firstName,
                            lastName,
                            email: username,
                            password,
                            type: type,
                            slug: slug,
                        })
                        .then(response => response.data)
                        .then(data => {
                            if (data.status !== 'ok') {
                                let args;

                                if (data.errors) {
                                    args = [
                                        data.errors.map(it => it.errorMessage).join(' - '),
                                        data
                                    ];
                                } else if (/can't save/i.test(data.msg)) {
                                    vm.invalidCredentials = true;
                                } else {
                                    args = [
                                        'unknown error',
                                        {
                                            errors: [{
                                                errorMessage: 'Oups ! Une erreur est survenue :/'
                                            }]
                                        }
                                    ];
                                }

                                throw ErrorFactory.newWebserviceError(...args);
                            }

                            $window.location.href = AuthenticationService.getRedirectRoute(data.redirectTo, true);
                        })
                        .catch(error => {
                            if (ErrorFactory.isWebserviceError(error)) {
                                // 200 Error
                                _(error.data.errors)
                                    .filter(it => Boolean(it.errorMessage))
                                    .forEach(it => {
                                        NoticeService.error(it.errorMessage);
                                    })
                                    .value();
                            }

                            vm.formLoading = false;
                        })
                    ;
                }

                function isAnythingLoading() {
                    return vm.formLoading || vm.facebookLoading || vm.googleLoading;
                }

                function openCGU() {
                    var x = screen.width/2 - 700/2 + FindLeftWindowBoundry();
                    var y = screen.height/2 - 700/2 + FindTopWindowBoundry();
                    $window.open('/terms', '_blank', 'height=700,width=700,,left='+x+',top='+y);
                }

                // Find Left Boundry of current Window
                function FindLeftWindowBoundry() {
                    // In Internet Explorer window.screenLeft is the window's left boundry
                    if (window.screenLeft) {
                        return window.screenLeft;
                    }

                    // In Firefox window.screenX is the window's left boundry
                    if (window.screenX) {
                        return window.screenX;
                    }
                    return 0;
                }
                // Find Top Boundry of current Window
                function FindTopWindowBoundry() {
                    // In Internet Explorer window.screenLeft is the window's top boundry
                    if (window.screenTop) {
                        return window.screenTop;
                    }

                    // In Firefox window.screenY is the window's top boundry
                    if (window.screenY) {
                        return window.screenY;
                    }
                    return 0;
                }

                function handleCookieActivatorClick(specificConsent) {
                    switch (specificConsent) {
                        case 'facebook':
                            CookiesConsentService.setCookiesConsent({ connect_facebook: true });
                            vm.facebookActivated = true;
                            vm.googleActivated = false;
                            break;
                        case 'google':
                            CookiesConsentService.setCookiesConsent({ connect_google: true });
                            vm.googleActivated = true;
                            vm.facebookActivated = false;
                            break;
                        default:
                            return null;
                    }
                }

                (() => {
                    if (vm.type === 'job') {
                        WizAppAnalyticsService.trackPageView(`/register/job/${vm.slug}`);
                    }
                    else {
                        WizAppAnalyticsService.trackPageView(`/register/${vm.type || 'home'}`);
                    }
                })();
            }
        ],
        // language=HTML
        template:
                `
            <form
                data-ng-submit="$ctrl.onSubmit()"
            >
                <div class="row">
                    <div class="col col-sm-6 col-xs-12">
                        <form-control
                            type="text"
                            input-id="register_firstName"
                            name="firstName"
                            input-class="form-control form-control--big form-control--identity"
                            ng-model="$ctrl.firstName"
                            label-class="font-size-tiny"
                            label-text="{{ 'wizbii.profile.messages.form.label.identity.firstname' | trans }}"
                            required
                        ></form-control>

                        
                    </div>
                    <div class="col col-sm-6 col-xs-12">
                        <form-control
                            type="text"
                            input-id="register_lastName"
                            name="lastName"
                            input-class="form-control form-control--big form-control--identity"
                            ng-model="$ctrl.lastName"
                            label-class="font-size-tiny"
                            label-text="{{ 'wizbii.profile.messages.form.label.identity.lastname' | trans }}"
                            required
                        ></form-control>
                    </div>
                </div>
                
                <form-control
                    type="email"
                    input-id="register_username"
                    name="email"
                    input-class="form-control form-control--big"
                    ng-model="$ctrl.username"
                    label-class="font-size-tiny"
                    label-text="{{ 'wizbii.onboarding.messages.form.label.email' | trans }}"
                    required
                    on-change="$ctrl.resetCredentialsValidity()"
                ></form-control>

                <form-control
                    type="password"
                    input-id="register_password"
                    name="password"
                    input-class="form-control form-control--big"
                    ng-model="$ctrl.password"
                    label-class="font-size-tiny"
                    label-text="{{ 'wizbii.onboarding.messages.form.label.password' | trans }}"
                    required
                    on-change="$ctrl.resetCredentialsValidity()"
                ></form-control>

                <div
                    ng-if="$ctrl.invalidCredentials"
                    class="text-error font-weight-medium text-center"
                >
                    {[:: 'wizbii.registerlayer.messages.form.invalidcredentials' | trans ]}
                </div>

                <div class="flex flex--start text-darker font-weight-regular font-size-base-small-down lower-margin-bottom margin-top-gutter">
                    <span class="margin-right-inner">
                        <input
                            id="acceptCgu"
                            type="checkbox"
                            class="no-margin"
                            data-ng-model="$crtl.cguAccepted"
                        >
                    </span>
                    <span>
                        <label
                            for="acceptCgu"
                            data-ng-bind-html="'wizbii.registerlayer.messages.label.acceptdatasharingandcgu' | trans"
                        ></label>
                        <a class="white-space-nowrap" target="_blank" href="/terms">{[:: 'wizbii.registerlayer.messages.link.acceptdatasharingandcgu'|trans ]}</a>
                        {[:: 'wizbii.utils.and'|trans ]} 
                        <a class="white-space-nowrap" target="_blank" href="/privacy-policy">{[:: 'wizbii.registerlayer.messages.label.privacypolicy' | trans ]}</a>
                    </span>
                </div>

                <button
                    type="submit"
                    class="button button--secondary button--block margin-top-gutter margin-top-large--sm-up button--font-size-important"
                    data-ng-disabled="!$crtl.cguAccepted || $ctrl.isAnythingLoading()"
                >
                    {[:: 'wizbii.core.messages.action.register'|trans ]}
                </button>

                <div class="side-separators text-center margin-top-gutter margin-bottom-gutter">
                    <span class="padding-left-inner padding-right-inner">{[:: 'wizbii.core.messages.word.or'|trans|lowercase ]}</span>
                </div>

                <div class="row">
                    <div class="col col-xs-12 col-sm-6">
                        <facebook-connect></facebook-connect>
                    </div>
                    
                    <div class="col col-xs-12 col-sm-6">
                        <google-connect></google-connect>
                    </div>
                </div>
                
                <div class="padding-top-gutter text-center font-size-base-small-down">
                    <span data-ng-if="$ctrl.facebookCookieActivator && !$ctrl.facebookActivated">
                        {[:: 'wizbii.onboarding.messages.form.error.facebookconsent'|trans ]}
                        <a data-ng-click="$ctrl.handleCookieActivatorClick('facebook')">{[:: 'wizbii.onboarding.messages.form.error.consentlink'|trans ]}</a>
                    </span>
                    <span data-ng-if="$ctrl.googleCookieActivator && !$ctrl.googleActivated">
                        {[:: 'wizbii.onboarding.messages.form.error.googleconsent'|trans ]}
                        <a data-ng-click="$ctrl.handleCookieActivatorClick('google')">{[:: 'wizbii.onboarding.messages.form.error.consentlink'|trans ]}</a>
                    </span>
                    <span data-ng-if="$ctrl.facebookActivated && !$ctrl.googleCookieActivator">
                        {[:: 'wizbii.onboarding.messages.form.error.facebookactivated'|trans ]}
                    </span>
                    <span data-ng-if="$ctrl.googleActivated && !$ctrl.facebookCookieActivator">
                        {[:: 'wizbii.onboarding.messages.form.error.googleactivated'|trans ]}
                    </span>
                </div>
            </form>
        `,
    });
